import styled from 'styled-components';
import { Menu } from 'antd';

export const UiMenu = styled(Menu)`
`;